module.exports = __webpack_public_path__ + "img/jackfruit-350x184.8c77a40b.jpg";